import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  container: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    gap: (props: { maxWidth?: number; size: "large" | "medium" | "small" }) =>
      props.size === "small" ? 0 : props.size === "medium" ? "var(--spacing-x05, 2px)" : "var(--spacing-x1, 4px)",
    maxWidth: (props: { maxWidth?: number }) => (props.maxWidth ? `${props.maxWidth}px` : "unset"),
  },
  body: {
    whiteSpace: "pre-line",
  },
});
